export default {
  title: 'Model Report',
  kpiLabel: 'KPI',
  aboutOptimalZones: 'About Optimal Zones',
  zone1Label: 'Zone 1:',
  zone1Description: 'This range should generally be avoided, as it falls below a Minimum Spending Threshold, resulting in negligible contributions. Any dollars spent in this zone are essentially wasted.',
  zone2Label: 'Zone 2:',
  zone2Description: 'In this range, dollars spent begin to show a small but rapidly growing marginal contribution. Typically, small increases in spending yield high gains in marginal contribution, until the point where Maximum Marginal Contribution is reached (marking the end of this zone).',
  zone3Label: 'Zone 3:',
  zone3Description: 'This range, along with the next, is generally considered "optimal". As spending increases in this range, the marginal contribution of each additional dollar spent gradually diminishes, although the Return On Ad Spend (ROAS) for each dollar continues to grow. This means that, even though the marginal contribution becomes smaller, it\'s still efficient to continue spending because the overall contribution grows. This continues up to the point where the Maximum ROAS is reached (the end of this zone).',
  zone4Label: 'Zone 4:',
  zone4Description: 'This range, along with the previous one, is generally considered "optimal". However, unlike in Zone 3, as spending increases in this range, ROAS gradually decreases, making further spending increasingly less efficient. This is because the contribution of every dollar diminishes in comparison to the amount being spent. This trend continues until reaching the point of Diminishing Returns, which represents the maximum recommended spending level. Beyond this point, any additional dollar spent yields insignificant returns, and is essentially wasted.',
  zone5Label: 'Zone 5:',
  zone5Description: 'Similar to Zone 1, this range generally should be avoided, as it represents spending beyond what is efficient. In this zone, the contribution of each additional dollar is so small that it\'s essentially a waste of resources.',
  ok: 'Ok',
  averageCpiTitle: 'Average CPI',
  averageCpiDescription: 'Enter average Cost Per Impression (MXN) for each media channel:',
  cancel: 'Cancel',
  save: 'Save',
  shareModelReport: 'Share Model Report',
  enableSharing: 'Enable sharing for this model report',
  shareLinkLabel: 'Share Link',
  close: 'Close',
  linkCopied: 'Link copied to clipboard!',
  manageAccess: 'Manage Access',
  spendLabel: 'Spend',
  totalSpendInfo: 'Total media spend during the period of the report.',
  totalSalesInfo: 'Total {kpiName} reported during the period of the report.',
  fullPeriodTab: 'Full Period',
  monthlyDetailTab: 'Monthly Detail',
  segmentsDetailTab: 'Segments Detail',
  adminTab: 'Admin',
  modelFit: 'Model Fit',
  modelFitInfo: 'Comparison of the actual KPI being modeled vs. the model\'s predicted values. It is expected that the predicted curve follows closely the actual values being modeled.',
  mapeLabel: 'MAPE (%)',
  mapeInfo: 'MAPE stands for "Mean Absolute Percentage Error", and it\'s a measure of how accurate the model is. A low MAPE value indicates a small difference, in average, between the actual KPI vs. the model\'s predicted values.',
  raeLabel: 'RAE (%)',
  raeInfo: 'RAE stands for "Relative Absolute Error", and it\'s a measure of how accurate the model is. Unlike the MAPE, the RAE accumulates the absolute error between the actual KPI vs. the model\'s predicted values across the entire period relative to the variation of the KPI vs the KPIs average in the same period. A low RAE value indicates a small difference, in total and relative to the KPI\'s variability, between the actual KPI vs. the model\'s predicted values.',
  correlationLabel: 'Correlation (%)',
  correlationInfo: 'Measure of how correlated is the Marketing Incremental with the KPI. High correlation values are indicative that marketing is indeed a measurable driver of the KPI, which in turn result in more robust models.',
  salesDecompositionTitle: '{kpiName} Decomposition',
  salesDecompositionInfo: 'Decomposition of the KPI among the different components of the model. While these vary from model to model, the following are the most frequent:',
  baseLabel: 'Base',
  baseDescription: 'is the portion of {kpiName} that cannot be attributed directly to the different marketing actions that took place during each period, rather it\'s the long-term result of past marketing activities.',
  mediaLabel: 'Media',
  mediaDescription: 'is the portion of {kpiName} that is attributed specifically to media spending that happened during the period.',
  seasonalityLabel: 'Seasonality',
  seasonalityDescription: 'accounts for {kpiName} that are simply attributable to cyclic factors that repeat over time, as well as other one-time events that have a direct effect over {kpiName}.',
  noiseLabel: 'Noise',
  noiseDescription: 'is the small portion of {kpiName} that cannot be attributed to any of the variables in the model, nor does it have a somewhat structured and predictable behavior as the base, therefore becoming noise in the model.',
  mediaMixTitle: 'Media Mix',
  mediaAttributedDecomposition: 'Media Attributed {kpiName} Decomposition',
  mediaAttributedDecompositionInfo: 'Detailed decomposition of the Media Component into its individual vehicles (or groups of them).',
  saturationCurves: 'Saturation Curves',
  generalViewTab: 'General View',
  optimalZonesTab: 'Optimal Zones',
  spendUnit: 'Spend Unit',
  editAverageCpi: 'Edit Average Cost Per Impression',
  showHistoricalDatapoints: 'Show historical spend datapoints',
  exportCurves: 'Export curves',
  decayCurves: 'Decay Curves',
  impactPercent: 'Impact (%/100)',
  periods: 'Periods',
  months: 'Months',
  weeks: 'Weeks',
  seasonalityEffects: 'Seasonality Effects',
  effectLabel: 'Effect',
  mediaSpendTitle: 'Media Spend',
  mediaMix: 'Media Mix',
  spendPercent: 'Spend %',
  salesDecompositionByPeriod: '{kpiName} Decomposition by Period',
  mediaAttributionByPeriod: 'Media Attribution by Period',
  pricingEffect: 'Pricing Effect',
  priceValue: 'Price Value',
  priceEffect: 'Price Effect',
  distributionEffect: 'Distribution Effect',
  distributionValue: 'Distribution Value',
  quarterlyAverageTotalRoas: 'Quarterly Average Total ROAS',
  quarterlyAverageRoasByMedia: 'Quarterly Average ROAS by Media',
  segmentsContributionInfo: 'Estimated {kpiName} contribution by demographic segment',
  rawReportOutput: 'RAW Report Output',
  customization: 'Customization',
  injectChanges: 'Inject changes',
  buildingModelReport: 'Building Model Report...',
  prediction: 'Prediction',
  real: 'Real'
}
